import type { BackgroundValue } from '@elfsight/configurator-contracts';
import { isTransparentBackground } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';

interface GetBackground {
  background: BackgroundValue;
  timerColor: string;
  withoutTransparent?: boolean;
}

export const getBackground = ({
  background,
  timerColor,
  withoutTransparent = true
}: GetBackground) => {
  if (isTransparentBackground(background) && withoutTransparent) {
    return {
      ...background,
      color: getInvertedColor(timerColor)
    };
  }

  return background;
};
